﻿export const initialise = () => {
    const overlay = document.querySelector<HTMLDialogElement>('#dialog-search-overlay')
    if (!overlay) return

    const dialogInputSearch = document.querySelector<HTMLInputElement>('#dialog-search-overlay .attrax-search-widget .attrax-form-item__input')
    const dialogWidgetSearch = document.querySelector<HTMLDivElement>('#dialog-search-overlay .dialog-search-overlay__widget-search')
    const buttonClose = document.querySelector<HTMLButtonElement>('#dialog-search-overlay .dialog-search-overlay__button-close')
    const buttonOpen = document.querySelector<HTMLButtonElement>('#header .header__button-open-dialog-search-overlay')
    const heading = document.querySelector<HTMLHeadingElement>('#dialog-search-overlay .dialog-search-overlay__heading')
    if (!dialogInputSearch || !dialogWidgetSearch || !buttonClose || !buttonOpen || !heading) return

    bindEvents(overlay, buttonClose, buttonOpen)
    addLanguagePackEntries(buttonClose, buttonOpen, heading)
    autocompleteSuggestions(dialogWidgetSearch)
}

export const openOverlay = (overlay: HTMLDialogElement) => {
    if (overlay.open) return
    overlay.showModal()
    document.body.classList.add('header--open')
}
export const closeOverlay = (overlay: HTMLDialogElement) => {
    if (!overlay.open) return
    overlay.close()
    document.body.classList.remove('header--open')
}

const bindEvents = (overlay: HTMLDialogElement, buttonClose: HTMLButtonElement, buttonOpen: HTMLButtonElement) => {
    buttonOpen.addEventListener('click', () => {
        openOverlay(overlay)
    })

    buttonClose.addEventListener('click', () => {
        closeOverlay(overlay)
    })

    overlay.addEventListener('close', () => {
        document.body.classList.remove('header--open')
    })
}

const addLanguagePackEntries = (buttonClose: HTMLButtonElement, buttonOpen: HTMLButtonElement, heading: HTMLHeadElement) => {
    buttonClose.setAttribute('aria-label', '{{js.dialog.search-overlay.button-close.aria-label}}')
    buttonOpen.setAttribute('aria-label', '{{js.dialog.search-overlay.button-open.aria-label}}')
    heading.textContent = '{{js.dialog.search-overlay.heading.content}}'
}

const autocompleteSuggestions = (dialogWidgetSearch: HTMLDivElement) => {
    const autocompleteSuggestion = document.querySelector<HTMLElement>('.dialog-search-overlay__widget-search.autocomplete-suggestions')
    if (!autocompleteSuggestion) return

    autocompleteSuggestion.setAttribute('popover', '')
    dialogWidgetSearch?.appendChild(autocompleteSuggestion)
}